import gql from 'graphql-tag';

export const deleteShiftTurnover = gql`
  mutation deleteShiftTurnover($id: ID!) {
    deleteShiftTurnover(id: $id) {
      value
    }
  }
`;
